<template>
  <div>
    <global-selector/>
    <div
      v-if="showHeadingsAndFilters"
      id="divDashboard">
      <DashboardHeader/>
      <div
        v-if="spDataPopulated"
        class="cf mw-parent">
        <div
          :class="panelWidthClass"
          class="fl bg-terciary"
        >
          <SPPanel
            v-for="i in leftColumnInstances"
            :key="'pnl' + i"
            :instance="i"
            class="bg-white" />
        </div>
        <div v-if="!useDoubleWidePanels">
          <div
            :class="panelWidthClass"
            class="fl bg-terciary"
          >
            <SPPanel
              v-for="i in rightColumnInstances"
              :key="'pnl' + i"
              :instance="i"
              class="bg-white" />
          </div>
        </div>
      </div>
      <SPPageFootnotes />
      <!-- <SPPanel
        :instance="0"
        :class="panelWidthClass"
        v-if="spDataPopulated"/> -->
      <!-- <SPStratFilters/> -->
      <!-- <SPTempDisplayRawSPData
        v-if="showDebugIds && spDataPopulated"
        :table-data="spData"
        table-label="Unfiltered data:"/> -->
    </div>

  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import GlobalSelector from './SPGlobalSelector';
import DashboardHeader from './SPDashboardHeader';
import SPPanel from './SPPanel';
import SPStratFilters from './SPStratFilters';
// import SPTempDisplayRawSPData from './SPTempDisplayRawSPData';
import SPPageFootnotes from '../common/PageFootnotes';

export default {
  components: {
    GlobalSelector,
    DashboardHeader,
    SPPanel,
    SPStratFilters,
    // SPTempDisplayRawSPData,
    SPPageFootnotes,
  },
  computed: {
    ...mapState({
      showHeadingsAndFilters: state => state.SP.flags.showHeadingsAndFilters,
      spData: state => state.SP.spData,
      indicators: state => state.SP.indicators,
      showDebugIds: state => state.flags.showDebugIds,
      categoryId: state => state.SP.GSGo.categoryId,
    }),
    printerFriendly() {
      return this.$store.getters.printerFriendly;
    },
    useDoubleWidePanels() {
      return this.$store.getters['SP/useDoubleWidePanels'];
    },
    panelWidthClass() {
      return this.useDoubleWidePanels || this.printerFriendly ? 'w-100 mw-dw' : 'w-50 mw';
    },
    leftColumnInstances() {
      const nums = [];
      let i;
      for (i = 0; i < this.indicators.length; i += (this.useDoubleWidePanels ? 1 : 2)) {
        nums.push(i);
      }
      return nums;
    },
    rightColumnInstances() {
      if (this.useDoubleWidePanels) return [];
      const nums = [];
      let i;
      for (i = 1; i < this.indicators.length; i += 2) {
        nums.push(i);
      }
      return nums;
    },
    spDataPopulated() {
      return !_.isEmpty(this.spData);
    },
  },
};
</script>

<style scoped>
  .w-50 {
    width: 50%;
  }
  .w-100 {
    width: 100%;
  }
  .cf:before,
  .cf:after   { content: " "; display: table; }
  .cf:after   { clear: both; }
  .cf         { *zoom: 1; }
  .fl {float: left;}
  .bg-terciary {
    background: #DEEEE9;
  }
  .bg-white {
    background: white;
  }
  /* #64496 DHDS: SP legend items missing or cut-off in narrow viewport */
  .mw {
    min-width: 530px;
  }
  .mw-dw {
    min-width: 1060px;
  }
  @media (min-width: 992px) {
    .mw-parent {
      min-width: 1060px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SP/SmallPanels.vue